/* Only one video plays at a time */
document.addEventListener('play', function (event) {
  var t = event.target;
  if (t.tagName !== 'VIDEO') return;
  document.querySelectorAll('video').forEach(function (video) {
    if (video !== t) video.pause();
  });
}, true);

/* KDIMZ - Mobile video presentation (phones only, under 750px).
   Scroll depth, entrance reveal, touch depth, swipe follow, and a View
   Product button on the hero video. Video sources and playback logic
   are unchanged. */
(function () {
  if (!window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = '.krh-vid-in, .kc-media, .video-section__media';
  var cards = [];
  var raf = 0;
  var started = false;
  var ICON_ARROW = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M2 8h11M9 4l4 4-4 4"/></svg>';

  function clamp(n, a, b) { return n < a ? a : n > b ? b : n; }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function update() {
    raf = 0;
    var vh = window.innerHeight || 1;
    var vals = [];
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (!c.kvpVis || !c.parentElement) { vals.push(null); continue; }
      var r = c.parentElement.getBoundingClientRect();
      if (!r.height) { vals.push(null); continue; }
      vals.push(clamp((r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2), -1, 1));
    }
    for (var j = 0; j < cards.length; j++) {
      if (vals[j] === null) continue;
      cards[j].style.setProperty('--kvp-p', vals[j].toFixed(3));
    }
  }
  function queue() { if (!reduce && !raf) raf = requestAnimationFrame(update); }

  function reveal(c) {
    if (!c.classList.contains('kvp-pre')) return;
    c.classList.add('kvp-reveal');
    requestAnimationFrame(function () { c.classList.remove('kvp-pre'); });
    setTimeout(function () { c.classList.remove('kvp-reveal'); }, 1400);
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var c = e.target;
      c.kvpVis = e.isIntersecting;
      c.classList.toggle('kvp-live', e.isIntersecting);
      if (e.isIntersecting && e.intersectionRatio >= 0.15) reveal(c);
    });
    queue();
  }, { threshold: [0, 0.15] }) : null;

  function setup(c) {
    if (c.kvpReady) return;
    c.kvpReady = true;
    cards.push(c);
    c.classList.add('kvp-card');
    var isHero = c.classList.contains('krh-vid-in');

    if (!reduce && !isHero && io) {
      var r = c.getBoundingClientRect();
      if (r.top > window.innerHeight * 0.92) c.classList.add('kvp-pre');
    }

    if (!reduce) {
      var off = function () { c.classList.remove('kvp-press'); };
      c.addEventListener('pointerdown', function (e) {
        if (e.target.closest && e.target.closest('a')) return;
        c.classList.add('kvp-press');
      }, { passive: true });
      c.addEventListener('pointerup', off, { passive: true });
      c.addEventListener('pointercancel', off, { passive: true });
      c.addEventListener('pointerleave', off, { passive: true });
    }

    /* View Product button directly on the video (when a product is linked) */
    var purl = c.getAttribute('data-kvp-url');
    if (purl && !c.querySelector('.kvp-view')) {
      var a = document.createElement('a');
      a.className = 'kvp-view';
      a.href = purl;
      a.innerHTML = '<span>' + esc(c.getAttribute('data-kvp-label') || 'View Product') + '</span><i>' + ICON_ARROW + '</i>';
      c.appendChild(a);
    }

    if (io) io.observe(c);
    else { c.kvpVis = true; c.classList.add('kvp-live'); }
  }

  function bindSwipe(root) {
    if (root.kvpSwipe || reduce) return;
    root.kvpSwipe = true;
    var x0 = 0, y0 = 0, axis = '', card = null;
    root.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      x0 = t.clientX; y0 = t.clientY; axis = '';
      card = root.querySelector('.kc-slide.is-active .kc-media');
    }, { passive: true });
    root.addEventListener('touchmove', function (e) {
      if (!card) return;
      var t = e.touches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (!axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (axis !== 'x') return;
      card.classList.add('kvp-drag');
      card.style.setProperty('--kvp-dx', clamp(dx, -140, 140).toFixed(1));
    }, { passive: true });
    function end() {
      if (!card) return;
      card.classList.remove('kvp-drag');
      card.style.setProperty('--kvp-dx', '0');
      card = null;
    }
    root.addEventListener('touchend', end, { passive: true });
    root.addEventListener('touchcancel', end, { passive: true });
  }

  function scan(scope) {
    var s = scope || document;
    s.querySelectorAll(SEL).forEach(setup);
    s.querySelectorAll('.kcs').forEach(bindSwipe);
    queue();
  }
  function start() {
    if (started || !mq.matches) return;
    started = true;
    document.documentElement.classList.add('kvp-on');
    scan();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  }
  if (mq.addEventListener) mq.addEventListener('change', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
